export default __webpack_public_path__ + "static/media/019-lollipop.00ec8266.svg";